import { AfterViewChecked, AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { Fidelity } from 'src/app/shared/Interfaces/fidelity';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import IMask from 'imask';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.css', "../../../assets/styles/global/_modal.scss"]
})
export class UserViewComponent implements OnInit, AfterViewInit, OnDestroy{

  @ViewChild('inputPhone') inputPhone!: ElementRef;
  @ViewChild('inputName') inputName!: ElementRef;
  @ViewChild('inputBirth') inputBirth!: ElementRef;
  private phoneMask: any;
  private birthMask: any;
  foundUser = false;
  openLogOut: boolean = false;
  openDeleteModal: boolean = false;
  deleteAccountState: 'confirm' | 'loading' | 'success' = 'confirm';
  userRequest!: Cliente | undefined;
  user!: Cliente;
  alterationButton: boolean = false;
  nameCompany: string = '';
  userConfirmation = false;
  name: string = '';
  birthData: string = '';
  phoneNumber: string = '';
  id_customer: string = '';
  editUser = false;
  lengthInputName: any;
  lengthInputPhone = false;
  lengthInputBirth = true;
  company!: Company;
  corretFormatPhoneNumber: any;
  correctFormatBirth: any
  fidelityUser!: Fidelity;
  fidelityGet: boolean = false;
  showTopMenu: boolean = false;
  typeParam!: typeInterface;
  requiredBirth = false;
  submit: boolean = false;
  couponsQuantity: number = 0;
  private destroy$ = new Subject<void>();

  constructor(
    private layout: LayoutComponent,
    private toastr: ToastrService,
    private router: Router,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private apiService: ApiService
  ){
    this.connection.nameCompany$
    .pipe(takeUntil(this.destroy$))
    .subscribe(newNameCompany => {
      this.nameCompany = newNameCompany;
    });

    this.connection.typeParam$
    .pipe(takeUntil(this.destroy$))
    .subscribe(newTypeParam => {
      this.typeParam = newTypeParam;
    });

    this.connection.fidelity$
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      this.fidelityUser = data;
      this.fidelityGet = true;
    });

    this.connection.company$
    .pipe(takeUntil(this.destroy$))
    .subscribe(newCompany => {
      this.company = newCompany;

      if (this.company) {
        this.connection.getUser(this.company.company.id_company);
      }

      if (
        this.company?.company?.id_company?.toString() ===
        'f33fcb89-4d42-4745-b090-212cd6f359bd'
      ) {
        this.requiredBirth = true;
      }
    });

    this.connection.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.userConfirmation = true;
        this.validCoupons();
        this.updateMask();
      }
      else{
        this.userConfirmation = false;
        this.user = user;
      }
    });

  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.addMask();
    this.onWindowResize();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Valida os cupons que não estão expirados
  validCoupons(){
    this.couponsQuantity = 0;
    if(this.user.coupons){
      this.user.coupons.forEach(coupon => {
        if(!coupon.expired){
          this.couponsQuantity ++;
        }
      });
    }

  }


//#region Log in User

  @HostListener('window:resize', [])
  onWindowResize(event?: any) {
    if(window.innerWidth <= 846){

      this.showTopMenu = false;
    }
    else{
      this.showTopMenu = true;
    }
    this.layout.checkScreenSize();
  }

  //Acionado toda vez que uma letra é digitada no input do nome
  onInputChangeName(event:any){
    console.log('Mas ta chegando aqui')
    const length = event.target.value.length
    if(length >= 3 )
    {
      this.lengthInputName = true;
    }
    else{
      this.lengthInputName = false;
    }

  }

  //Valida a data de aniversário
  validateBirthDate() {
    this.birthData = this.birthData.replace(/[^0-9/]/g, '');

    const onlyNumbers = this.birthData.replace(/\D/g, ''); 

    if (this.birthData && this.birthData.length > 0) {
      // Verifica o tamanho da data
      this.correctFormatBirth = onlyNumbers.length === 8;
      
      if (this.correctFormatBirth) {
        // Extrai dia, mês e ano
        const day = Number(onlyNumbers.substring(0, 2));
        const month = Number(onlyNumbers.substring(2, 4));
        const year = Number(onlyNumbers.substring(4, 8));
        
        //Verifica se os valores são números válidos
        if (isNaN(day) || isNaN(month) || isNaN(year)) {
          this.correctFormatBirth = false;
          return;
        }
        
        // Cria um objeto Date
        const birthDate = new Date(year, month - 1, day);
        
        // Verifica se a data é válida
        const isValidDate = (birthDate.getFullYear() === year && birthDate.getMonth() === month - 1 && birthDate.getDate() === day);
        
        // Verifica se a data está em um intervalo razoável de 120 anos
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 120;
        const maxYear = currentYear; // Não pode ser no futuro
        
        this.correctFormatBirth = isValidDate && year >= minYear && year <= maxYear;
      }
      
      this.lengthInputBirth = onlyNumbers.length === 8;
    } else {
      this.correctFormatBirth = undefined;
      this.lengthInputBirth = true;
    }
  }

  //Volta a pagina
  goback(): void{
    if(this.typeParam.type == 3)
    {
      this.router.navigate([this.nameCompany, 'B']);
    }
    else{

      this.router.navigate([this.nameCompany]);
    }
  }

  //Adiciona as mascaras de telefone e Aniversário
  addMask(){
    setTimeout(() => {
      if(this.inputPhone && this.inputBirth){
        this.phoneMask = IMask(this.inputPhone.nativeElement, {
          mask: '(00)00000-0000',
        });
        this.birthMask = IMask(this.inputBirth.nativeElement, {
          mask: '00/00/0000',
        });
        this.phoneMask.updateValue();
        this.birthMask.updateValue();
        console.log('Mask aplicado:', {phone: this.phoneMask, birth: this.birthMask})
      }
    }, 0);
  }

  //Atualiza as mascaras
  updateMask(){
    if(this.phoneMask && this.birthMask){
      setTimeout(() => {
        this.phoneMask.updateValue();
        this.birthMask.updateValue();
        console.log('Mask atualizado:', {phone: this.phoneMask, birth: this.birthMask})
      }, 0);
    }
  }

  //Navega até a view de fidelidade
  navigateFidelity(){
    this.router.navigate([this.nameCompany, 'fidelity']);
  }

  //Navega até a view de cupons
  navigateCoupons(){
    this.router.navigate([this.nameCompany, 'coupons']);
  }

  navigateCashbackHistory(){
    this.router.navigate([this.nameCompany, 'history-cashback']);
  }


  //#region Phone Number

    //Formata e valida o telefone do usuário
    formatPhoneNumber(phone: string): string {
      if (!phone) return '';
    
      let rawValue = phone.replace(/\D/g, '');
    
      const firstPart = rawValue.substring(0, 2);
      const secondPart = rawValue.substring(2, 7);
      const thirdPart = rawValue.substring(7, 11);
    
      if (rawValue.length <= 2) {
        return `(${firstPart}`;
      } else if (rawValue.length <= 7) {
        return `(${firstPart})${secondPart}`;
      } else {
        return `(${firstPart})${secondPart}-${thirdPart}`;
      }
    }

    //Valida se o input está prenchido corretamente
    validatePhoneNumber() {
      if(this.phoneNumber.replace(/\D/g, '').length > 0){
        this.corretFormatPhoneNumber = this.phoneNumber.replace(/\D/g, '').length === 11;

        if(this.phoneNumber.replace(/\D/g, '').length < 11){
          this.lengthInputPhone = false;
        }
        else{
          this.lengthInputPhone = true;
          this.phoneNumber = this.formatPhoneNumber(this.phoneNumber);
          this.getUserIsPhone(this.phoneNumber);
        }
      }
      else{
        this.corretFormatPhoneNumber = undefined;
        this.lengthInputPhone = false;
      }

    }

    //Busca o usuario pelo seu telefone
    getUserIsPhone(phoneNumber: string){
      let formatted = this.formatPhoneNumber(phoneNumber);

      if(formatted.length === 14){
        this.apiService.getUsuario(formatted, this.company.company.id_company).subscribe(
          (data) => {
            this.handleSuccessfulResponse(data)
          },
          (error) => {
            console.log('Usuario não cadastrado');
            this.handleError(error)
          }
        )
      }
    }

  //#endregion


  //#region Confirm

    //Assim que confirmado ele monta os objetos necessarios com os valores dos campos
    submitForm(){
      let userAddress = this.cacheService.getItemLocal('Address_Saved')

      this.submit = true;

      if(this.userRequest){
        if(this.userRequest.name != this.name || this.userRequest.phone != this.phoneNumber || this.userRequest.birthDate != this.birthData)
          {
            this.editUser = true;
            if(this.id_customer != this.userRequest.id_customer){
              this.id_customer = this.userRequest.id_customer
            }
        }
      }

      this.phoneNumber = this.formatPhoneNumber(this.phoneNumber);
      
      let document = '';
      if(this.userRequest){
        document = this.userRequest.document ?? '';
      }

      let cliente: Cliente = {
        name: this.name,
        phone: this.phoneNumber,
        id_customer: this.id_customer,
        document: document,
        birthDate: this.birthData
      } 
  
      if(this.foundUser == false)
        {
          this.apiService.postUsuario(cliente).subscribe(
            (data) => {
              console.log('Usuario cadastrado com sucesso');
  
              //Carrega com o novo id
              cliente.id_customer = data.response.Customer.id_customer;

              //Insere localmente
              this.cacheService.setItemLocal('user_key', cliente);

              //Realiza a requisição do usuário novamente
              this.connection.getUser(this.company.company.id_company);
  
              //Valida e remove os endereços salvos em cache.
              if(userAddress)
              {
                this.cacheService.removeItemLocal('Address_Saved')
              }

              this.toastr.success('Usuário cadastrado', 'Sucesso', { positionClass: 'toast-top-right', timeOut: 2000});
            },
            (error) => {
              console.error('Erro ao cadastrar usuario:', error);
              this.submit = false;
              this.apiService.getUsuario(this.phoneNumber, this.company.company.id_company).subscribe(
                (data) => {
                  this.handleSuccessfulResponse(data)
                },
                (error) => {
                  this.handleError(error)
                }
              )
            }
          );
      }
      else{
        if(this.editUser){
          this.pathUser();
        }
        else{
          this.cacheService.setItemLocal('user_key', cliente)                  
          this.connection.getUser(this.company.company.id_company);
        }

      }
  
    }

    //Atualiza as informações do Usuário
    pathUser(){
      this.apiService.patchUser(this.id_customer, this.name, this.phoneNumber, this.birthData).subscribe(
        (data) =>{

          const userKey: Cliente = {
            phone: data.response.phone,
            id_customer: data.response.id_customer,
            name: data.response.name,
            birthDate: data.response.birthDate
          }

          this.cacheService.setItemLocal('user_key', userKey);
          this.connection.getUser(this.company.company.id_company);
        },
        (error) =>{
          console.log('Erro ao editar usuario:', error);
      })
    }
  
    // Função para lidar com a resposta bem-sucedida
    private handleSuccessfulResponse(data: any): void {

      //Carrega as informações do Usuário
      const customer = data.response.customer;
      this.name = customer.name;
      this.birthData = customer.birthDate
      this.id_customer = customer.id_customer;
      this.validateBirthDate();

      //Abilita e valida as veriaveis visuais
      this.foundUser = true;
      this.alterationButton = true;
      this.lengthInputName = true;
      this.lengthInputPhone = true;

      //Atualiza as mascaras
      this.birthMask.value = this.birthData;
  
      //Carrega com as informações do usuário, na base
      const userKey = {
        phone: customer.phone,
        id_customer: customer.id_customer,
        name: customer.name,
        birthDate: customer.birthDate,
        document: customer.document
      }
      this.userRequest = userKey;
      
      //Retira o foco do input de número
      this.inputPhone.nativeElement.blur();
    }
  
    // Função para lidar com erros
    private handleError(error: any): void {
      if(error.status == 404){
        this.name = '';
        this.birthData = '';
        this.foundUser = false;
        this.lengthInputName = undefined;
        this.correctFormatBirth = undefined;
        this.alterationButton = false
        this.inputPhone.nativeElement.blur();
        this.inputName.nativeElement.focus();
      }
      else{}

    }

    //Desconecta o usuario
    disconnectUser(){
      this.submit = false;
      this.userRequest = undefined;
      this.openLogOut = false;
      this.cacheService.removeItemLocal('Address_Saved')
      this.cacheService.removeItemLocal('user_key');
      let clientEmpty!: Cliente;
      this.connection.updateUser(clientEmpty)
      this.user = clientEmpty
      this.userConfirmation = false;
      this.phoneNumber = '';
      this.name = '';
      this.birthData = '';
      this.corretFormatPhoneNumber = undefined;
      this.correctFormatBirth = undefined;
      this.lengthInputBirth = false;
      this.lengthInputName = undefined;
      this.lengthInputPhone = false;
      this.addMask();
      this.connection.getUser(this.company.company.id_company);
    }

    //Abre o modal de solicitação de exclusão
    openDeleteAccount(){
      this.deleteAccountState = 'confirm';
      this.openDeleteModal = true;
    }

    //Fecha o modal de exclusão
    closeDeleteModal(){
      this.openDeleteModal = false;
    }

    //Confirma a solicitação de exclusão de conta
    confirmDeleteRequest(){
      this.deleteAccountState = 'loading';

      this.apiService.requestAccountDeletion(this.user.id_customer).subscribe(
        (data) => {
          this.deleteAccountState = 'success';
          // Opcional: desconectar ou fechar após sucesso
          // setTimeout(() => {
          //   this.closeDeleteModal();
          //   this.disconnectUser();
          // }, 2000);
        },
        (error) => {
          console.error('Erro ao solicitar exclusão:', error);
          this.toastr.error('Erro ao solicitar exclusão da conta', 'Erro');
          this.deleteAccountState = 'confirm';
        }
      );
    }

  //#endregion

//#endregion

}
